<template>
  <b-modal centered ref="checkout-modal" id="checkOutModal" title="Check-Out" hide-footer>
    <b-form>
      <p>The pre-authorizated credit card hold of ${{ amount }} will expire automatically 24 hours after check-out.</p>
      <p class="mt-4">To capture all or a portion of the hold please visit your stripe portal.</p>
    </b-form>

    <b-row class="mx-0 mt-2">
      <b-col>
        <b-button class="my-2 px-3" variant="danger" @click="checkOut">
          Check-Out
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CheckOutModal",

data() {
    return {
      amount: 0,
    }
  },

  methods: {
    show(amount) {
      this.amount = amount;
      this.$refs['checkout-modal'].show();
    },

    hide() {
      this.$refs['checkout-modal'].hide();
    },

    checkOut() {
      this.$emit('checkout')
    }
  },
};
</script>
